import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ModalResetPassword } from "../components/modals/ModalResetPassword";

export default function ResetPassword() {
	const [searchParams] = useSearchParams();
	const [token] = useState(() => searchParams.get("token") ?? "");
	const [email] = useState(() => searchParams.get("email") ?? "");

	useEffect(() => {
		if (searchParams.has("token") || searchParams.has("email")) {
			const newUrl = window.location.pathname;
			window.history.replaceState({}, document.title, newUrl);
		}
	}, [searchParams]);

	return (
		<div className='min-h-screen flex items-center justify-center bg-slate-100'>
			<ModalResetPassword
				open={true}
				onClose={() => {}}
				token={token}
				email={email}
			/>
		</div>
	);
}
